import { useQuery } from "react-query";
import type { ProgramDto } from "common/models/api/models/ProgramDto";
import { Queries } from "ui/query/queries";
import type { QueryResult, UseCustomQueryOptions } from "ui/query/react-query-overrides";
import { programsApi } from "../api/programsApi";

export interface UseGetProgramParams {
    address?: string;
}

export default function useGetProgram<TData = ProgramDto>(
    { address }: UseGetProgramParams,
    { enabled = true, ...options }: UseCustomQueryOptions<ProgramDto, unknown, TData, (typeof Queries.PROGRAM | string | undefined)[]> = {},
): QueryResult<TData> {
    const safeAddress = address as string;

    return useQuery(
        [Queries.PROGRAM, address],
        async () => {
            const res = await programsApi.findByAddress(safeAddress);
            return res.data;
        },
        { enabled: address !== undefined && enabled, ...options },
    );
}
